module.exports = __webpack_public_path__ + "static/img/floor3-scmzwwg.9389575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-scmzwwg.png
// module id = iBZ3
// module chunks = 1